/* unplugin-vue-components disabled */import { render } from "./xuShuiChi.vue?vue&type=template&id=f1932e08&scoped=true"
import script from "./xuShuiChi.vue?vue&type=script&lang=js"
export * from "./xuShuiChi.vue?vue&type=script&lang=js"

import "../../assets/css/init/column.less?vue&type=style&index=0&id=f1932e08&lang=less&scoped=true"
import "../../assets/css/service/service.less?vue&type=style&index=1&id=f1932e08&lang=less&scoped=true"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1932e08"]])

export default __exports__